<template>
  <div class="gf_pricing__faq__box gf_pricing__container">
    <div class="gf_pricing__faq__title">{{ $t("dataNewPlan.faq.top.label") }}</div>
    <div class="gf_pricing__faq__section row">
      <div class="gf_pricing__faq__section-left col-6">
        <div class="gf_pricing__faq__item" v-for="(item, key) in getFaqs.left" :key="key">
          <div class="gf_pricing__faq__item-icon">
            <img src="../assets/question.svg" alt="Question">
          </div>
          <div class="gf_pricing__faq__item-info">
            <div class="gf_pricing__faq__item-info--title" v-html="$t(item.title)"></div>
            <div class="gf_pricing__faq__item-info--desc" v-html="$t(item.description)"></div>
          </div>
        </div>
      </div>
      <div class="gf_pricing__faq__section-right col-6">
        <div class="gf_pricing__faq__item" v-for="(item, key) in getFaqs.right" :key="key">
          <div class="gf_pricing__faq__item-icon">
            <img src="../assets/question.svg" alt="Question">
          </div>
          <div class="gf_pricing__faq__item-info">
            <div class="gf_pricing__faq__item-info--title" v-html="$t(item.title)"></div>
            <div class="gf_pricing__faq__item-info--desc" v-html="$t(item.description)"></div>
          </div>
        </div>
        <div class="gf_pricing__faq__item gf_pricing__faq__item__more">
          <div class="gf_pricing__faq__item-icon">
            <img src="../assets/contact.svg" alt="Contact">
          </div>
          <div class="gf_pricing__faq__item-info">
            <div class="gf_pricing__faq__item-info--title">
              {{ $t("dataNewPlan.faq.contact.title") }}
            </div>
            <div class="gf_pricing__faq__item-info--link">
              <a href="#" @click.prevent="openLiveChat()">
                {{ $t("dataNewPlan.faq.contact.link") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import plan from "@/modules/Pricing/mixins/plan";

export default {
  name: "Pricingfaq",
  mixins: [plan()],
  methods: {
    openLiveChat() {
      this.$chatbox.show();
    },
  }
}
</script>

<style lang="scss">
.gf_pricing__faq__item-title--link {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3C67FF;
  cursor: pointer;
  &:hover {
    color: #2856F8;
  }
}

.gf_pricing__faq {
  &__title {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    text-align: center;
    color: map-get($text-light-mode, "high-contrast");
    margin-bottom: 40px;
    width: 100%;
    text-align: center;
  }

  &__item {
    padding: 40px;
    @media screen and (max-width: 1230px) {
      padding: 24px;
    }
    display: flex;
    margin-bottom: 24px;
    background: map-get($hybrid-shade-light, "100");
    border: 1px solid map-get($hybrid-shade-light, "400");
    border-radius: 3px;

    &:last-child {
      margin-bottom: 0;
    }

    &-icon {
      width: 24px;
      height: 24px;
      margin-right: 12px;
      display: flex;
      margin-top: 3px;
    }

    &-info {
      &--title {
        font-weight: 600;
        font-size: 20px;
        line-height: 150%;
        color: map-get($text-light-mode, "high-contrast");
      }

      &--desc {
        margin-top: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: map-get($text-light-mode, "low-contrast");
      }

      &--link {
        margin-top: 10px;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;

        a {
          color: map-get($primary-blue, "300");

          &:hover {
            color: map-get($primary-blue, "325");
          }
        }
      }
    }

    &__more {
      padding: 32px;

      .gf_pricing__faq__item-icon {
        width: 32px;
        height: 32px;
      }
    }
  }
}
</style>
